import React, {useEffect, useMemo, useState} from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale, GetUrlParams} from "../../components/Utils";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/RootReducer";
import {userLogin} from "./UsersSlice";
import { ChangeButtonHandler, ChangeHandler} from "../../components/FormElementTypes";
import {SpinnerOnTop} from "../../components/SpinnerOnTop";
import {LocalParams} from "../../components/LocalParams";
import {useAppDispatch} from "../../app/hooks";
import {UserDto} from "../Entity/User";
import {getCart} from "../Cart/CartSlice";
const LoginPage = () => {
  const locale = GetCurrentLocale();
  const dispatch = useAppDispatch();

  changeLanguage(locale);

  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const isRequesting = useSelector((state: RootState) => state.userRdc.isRequesting);
  const error = useSelector((state: RootState) => state.userRdc.error);

  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');

  const isExpiredSession = useMemo((): string|null => GetUrlParams()["expired_session"] ?? null, []);

  const onUserNameChanged: ChangeHandler = e => {
    setUserName(e.target.value);
  }

  const onPasswordChanged: ChangeHandler = e => {
    setPassword(e.target.value);
  }

  const onLoginRequestLoginPage: ChangeButtonHandler = e => {
    e.preventDefault();
    loginRequest(userName, password);
  }

  const loginRequest = (userName: string, password: string) => {
    localStorage.removeItem('tokenCart');
    dispatch(userLogin(userName, password, true))
      .then((user: UserDto) => {
        const tokenCart = user.customer?.tokenCart;
        if (tokenCart) {
          LocalParams.setItem("tokenCart", tokenCart);
          dispatch(getCart(tokenCart));
        }
      });
  };

useEffect(() => {
    if (isAuthenticated) {
      if ((document.referrer) && (! document.referrer.includes('login'))) {
        window.location.href = document.referrer;
      } else {
        window.location.href = '/';
      }
    }
  }, [isAuthenticated]);

  return (
    <div className="container py-5">
      <div className="login row align-items-center">
        <div className="col-lg-6">
          <div className="row justify-content-center">
            <div className="col-lg-8 card nobackground noborder noboxshadow">
              <div className="card-body">
                {
                  isRequesting ?
                    <SpinnerOnTop/>
                    :
                    isAuthenticated?
                      <div>
                        <h2>{t('authentifie')}</h2>
                        <p>{t('will_be_redirected')}</p>
                      </div>
                      :
                      <>
                        <form>
                          {
                            isExpiredSession ?
                              <div className="mb-3">
                                <span className="text-danger">{t('session_expired')}</span>
                              </div>
                            :null
                          }
                          <div className="mb-3">
                            <label className="form-label">{t('email')}</label>
                            <input name="email" className={ error ? "form-control is-invalid" : "form-control"} placeholder={t('example_mail')} value={userName} onChange={onUserNameChanged} type="email"/>
                          </div>
                          <div className="mb-3">
                            <label className="form-label">{t('password')}</label>
                            <a className="float-end" href={ "/" + locale + t('url_forgot_mdp')}>{ t('forgotten_password')}</a>
                            <input className={ error ? "form-control is-invalid" : "form-control"} value={password} onChange={onPasswordChanged} placeholder="●●●●●●●●" type="password"/>
                            {error && <div className="invalid-feedback">{t(error.message)}</div>}
                          </div>
                          <button onClick={onLoginRequestLoginPage} className="btn btn-primary width100" type="submit">
                            {t('login')}
                          </button>
                        </form>
                        <p className="text-divider my-4">{ t('no_account_yet')}</p>
                        <a href={ "/" + locale + t('url_create_account')} className="btn w-100 btn-light">{ t('create_account')}</a>
                      </>
                }
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <h1 className="display-4 text-white">{ t('welcome_back')}</h1>
          <p className="lead py-5 mb-0 text-white"> { t('connect_to_account')}</p>
        </div>
      </div>
    </div>
  )
}

export default LoginPage;
